/**
 * Estilos-base dos documentos HTML exibidos isolados no `PreviewHtmlSandbox`. Mora aqui, ao
 * lado de `documentoHtmlIsolado`, para quem monta o documento não importar a UI.
 */
export const ESTILOS_PREVIEW_DOCUMENTO = `body{font-family:system-ui,-apple-system,sans-serif;padding:16px;margin:0;color:#111827}table{border-collapse:collapse}td,th{border:1px solid #d1d5db;padding:4px 8px;font-size:13px}img{max-width:100%;height:auto}table.planilha{table-layout:fixed;font-size:12px}.planilha td,.planilha th{border:1px solid #d0d7de;padding:2px 6px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;vertical-align:top;text-align:left}.planilha th.cab{background:#f6f8fa;color:#57606a;font-weight:600;text-align:center}.planilha thead th{position:sticky;top:0;z-index:1}.planilha th.linha,.planilha .corner{position:sticky;left:0;z-index:1}.planilha .corner{z-index:2}.aviso{color:#57606a;font-size:12px;margin-top:8px}`;

/**
 * CSP do documento que embrulha HTML de origem não confiável.
 *
 * - `default-src 'none'` — nada carrega por default: barra script e o beacon de uma `<img>`
 *   remota, que vazaria IP e User-Agent de quem abre o documento;
 * - `img-src data: blob:` e `font-src data:` — imagens e fontes embutidas passam; `https:`
 *   fica fora de propósito, é o vetor;
 * - `style-src 'unsafe-inline'` — o `<style>` e os `style=` que o próprio documento traz;
 * - `base-uri 'none'` e `form-action 'none'` — não herdam de `default-src`: sem elas, um
 *   `<base>` redireciona todo link e um formulário posta para terceiro.
 *
 * ⚠️ Nenhuma diretiva barra `<meta http-equiv="refresh">`: quem cobre é o `sandbox` do iframe
 * do `PreviewHtmlSandbox`. Exibir este documento fora de um iframe com `sandbox` exige
 * sanitizar o HTML antes.
 */
const CSP_HTML_ISOLADO =
  "default-src 'none'; img-src data: blob:; style-src 'unsafe-inline'; font-src data:; base-uri 'none'; form-action 'none'";

/**
 * Documento HTML completo com a CSP acima no `<head>`, antes de qualquer conteúdo — nada no
 * corpo consegue afrouxá-la, só restringir mais.
 *
 * O `estilos` é interpolado cru: um `</style>` nele fecha o elemento. Aceitável porque o dano
 * para no próprio documento, que não executa script nem carrega subrecurso remoto.
 *
 * @example <iframe sandbox="" srcDoc={documentoHtmlIsolado(html, { estilos })} />
 */
export function documentoHtmlIsolado(html: string, opcoes: { estilos?: string } = {}): string {
  const estilos = opcoes.estilos ? `<style>${opcoes.estilos}</style>` : '';
  return `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${CSP_HTML_ISOLADO}">${estilos}</head><body>${html}</body></html>`;
}
